/*
 * PROPOSED SHOPIFY ASSET: assets/revenue-os-recommendation-publisher.js
 * OWNER-REVIEW DRAFT ONLY — DO NOT INSTALL
 */
(() => {
  'use strict';

  const INSTALLATION_AUTHORIZED = false;
  const LIVE_INGESTION_AUTHORIZED = false;
  const CUSTOM_EVENT_NAME = 'revenue_os:recommendation_interaction';
  const ALLOWED_INTERACTIONS = new Set([
    'recommendation_impression',
    'recommendation_click',
    'recommendation_cta_click',
    'recommendation_product_link_click',
  ]);
  const HANDLE_PATTERN = /^[a-z0-9][a-z0-9_-]{0,254}$/;
  const MAX_EVENTS_PER_PAGE = 50;

  if (INSTALLATION_AUTHORIZED !== true || LIVE_INGESTION_AUTHORIZED !== true) return;
  if (window.__revenueOsPublisherLoaded === true) return;
  window.__revenueOsPublisherLoaded = true;

  let analyticsAllowed = false;
  let eventCount = 0;
  const pageViewId = `page:${crypto.randomUUID()}`;
  const sessionStorageKey = 'revenue-os-anonymous-session-v1';

  function globalPrivacyControlEnabled() {
    return navigator.globalPrivacyControl === true;
  }

  function anonymousSessionId() {
    try {
      const existing = sessionStorage.getItem(sessionStorageKey);
      if (existing && /^session:[A-Za-z0-9-]{8,127}$/.test(existing)) return existing;
      const created = `session:${crypto.randomUUID()}`;
      sessionStorage.setItem(sessionStorageKey, created);
      return created;
    } catch {
      return `session:${crypto.randomUUID()}`;
    }
  }

  const sessionId = anonymousSessionId();

  function refreshConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    analyticsAllowed = Boolean(
      privacy &&
      privacy.analyticsProcessingAllowed() === true &&
      !globalPrivacyControlEnabled()
    );
  }

  function publish(root, eventName) {
    if (!analyticsAllowed || globalPrivacyControlEnabled()) return;
    if (!ALLOWED_INTERACTIONS.has(eventName) || eventCount >= MAX_EVENTS_PER_PAGE) return;

    const sourceProductHandle = root.dataset.revenueOsSourceHandle || '';
    const targetProductHandle = root.dataset.revenueOsTargetHandle || '';
    if (!HANDLE_PATTERN.test(sourceProductHandle) || !HANDLE_PATTERN.test(targetProductHandle)) return;
    if (sourceProductHandle === targetProductHandle) return;
    if (window.Shopify?.analytics?.publish instanceof Function !== true) return;

    eventCount += 1;
    window.Shopify.analytics.publish(CUSTOM_EVENT_NAME, {
      eventId: `event:${crypto.randomUUID()}`,
      eventName,
      occurredAt: new Date().toISOString(),
      sessionId,
      pageViewId,
      sourceProductHandle,
      targetProductHandle,
      placement: 'product_page',
      origin: 'manual_override',
      globalPrivacyControl: false,
    });
  }

  function bindComponent(root) {
    if (root.dataset.revenueOsMeasurementBound === 'true') return;
    root.dataset.revenueOsMeasurementBound = 'true';

    root.addEventListener('click', (event) => {
      const control = event.target.closest('[data-revenue-os-interaction]');
      if (!control || !root.contains(control)) return;
      publish(root, control.dataset.revenueOsInteraction || '');
    });

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      publish(root, 'recommendation_impression');
    }, { threshold: 0.25 });
    observer.observe(root);
  }

  function bindAll() {
    document.querySelectorAll('[data-revenue-os-measurement="phase-2c-3c"]')
      .forEach(bindComponent);
  }

  function initializePrivacy() {
    if (window.Shopify?.loadFeatures instanceof Function !== true) return;
    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' },
    ], (error) => {
      if (error) return;
      refreshConsent();
      document.addEventListener('visitorConsentCollected', refreshConsent);
      bindAll();
      document.addEventListener('shopify:section:load', bindAll);
    });
  }

  initializePrivacy();
})();
    